// 文件导出
export function exportDocument (url, params, name) {
  this.$http.post(url, params, {responseType: 'blob'}).then(res => {
    const link = document.createElement('a')
    let blob = new Blob([res.data], { type: 'application/x-excel' })
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    link.download = name || '导出数据.xlsx'
    document.body.appendChild(link)
    link.click()
    window.URL.revokeObjectURL(link.href)
    document.body.removeChild(link)
    this.$message.success('导出成功')
  }).catch(() => {
    this.$message.success('导出失败')
  })
}

// 下载图片
export function downloadImageNew (url, name) {
  // 下载图片地址和图片名
  let image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
  image.onload = function () {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    const url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
    const a = document.createElement('a') // 生成一个a元素
    const event = new MouseEvent('click') // 创建一个单击事件
    a.download = name || '图片' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
}



// WEBPACK FOOTER //
// ./src/util/index.js